module.exports = __webpack_public_path__ + "assets/img/user-6.ce2c4c78.jpg";